import { render, staticRenderFns } from "./RsaGestioneAmbulatorialeListPage.vue?vue&type=template&id=0d985d92"
import script from "./RsaGestioneAmbulatorialeListPage.vue?vue&type=script&lang=js"
export * from "./RsaGestioneAmbulatorialeListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports